<template>
  <v-card elevation="1" class="transport" style="width: 100%" flat tile>
    <v-card-actions>
      <h4 class="pl-4 subtitle-2">{{ title }}</h4>
      <v-spacer />
      <v-btn icon @click="showMore = !showMore">
        <v-icon>{{ showMore ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-expand-transition>
      <div class="grey lighten-4" v-show="showMore">
        <v-row class="pa-4 no-gutters">
          <v-col class="d-flex justify-center py-0 mb-2" cols="12">
            <v-date-picker
              width="15vw"
              color="red"
              v-model="selectedDate"
              :show-current="initialDate"
              no-title
              @input="handleDateFilter"
              :allowed-dates="allowedDates(handleItems(dateFieldName)?.items)"
              locale="fr"
              :min="initialDate"
              @click:month="filterByMonth"
            ></v-date-picker>
          </v-col>
          <template
            v-if="handleItems('duration')"
          >
            <v-col class="py-0 mb-2" cols="6">
              <span class="mb-2 caption">{{handleItems('duration').label}}</span>
              <v-select
                v-model="selectedDuration"
                hide-details
                class="white mt-1"
                :items="handleItems('duration').items"
                item-text="value"
                :menu-props="{ bottom: true, offsetY: true }"
                dense
                outlined
                @input="handleDurationFilter"
              ></v-select></v-col>
            <v-col class="py-0 pl-2 mb-2" cols="6">
              <span class="mb-2 caption">Variation depart</span>
              <v-switch
                :disabled="selectedDate ? false : true"
                class="mt-2"
                v-model="selectedVariation"
                hide-details
                @change="handleDateFilter"
              >
                <template v-slot:label>
                  <span :class="selectedVariation ? 'black--text' : ''">+/- {{ departDelta }} jours</span>
                </template>
              </v-switch>
            </v-col>
          </template>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export default {
  props: {
    title: String,
    departDelta: Number,
    isVariationActive: {
      type: Boolean,
      default: false
    },
    fields: Array,
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMore: this.show,
      initialDate: null,
      selectedDate: null, // new Date().toISOString().substr(0, 10),
      selectedDuration: null,
      selectedVariation: this.isVariationActive,
      menu: false,
      items: [],
      variationItems: [1,2,3,4,5,6,7,8,9],
      dateFieldName: 'date'
    }
  },
  computed: {
    date() {
      return this.$store.state.filters.find(filter => filter.field === this.dateFieldName);
    },
    duration() {
      return this.$store.state.filters.find(filter => filter.field === 'duration');
    }
  },
  methods: {
    handleItems(fieldName) { // This is called by a static string, we can define it on facets.json and this way will be dynamic
      let field = this.fields.find(f => f.field === fieldName);
      return field;
    },
    allowedDates(dates){
      dates = dates.map(date => {
        return dayjs.utc(date.value, 'x').format('YYYY-MM-DD')
      })
      return (val) => dates.indexOf(val) !== -1 ? true : false;
    },
    filterByMonth(val) {
      if(val){
        let dateActive = this.$store.state.filters.find(filter => filter.field === this.dateFieldName);

        if(dateActive) {
          this.$store.commit('removeFilter', {
            id: dateActive.id
          })
        }

        this.$store.commit('setFilter', {
          field: this.dateFieldName,
          from: dayjs.utc(val, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
          to: dayjs.utc(val, 'YYYY-MM').endOf('month').format('YYYY-MM-DD'),
          id: `${this.dateFieldName}-${val}`,
          breadcrumbs: true,
          title: this.title,
          type: "range",
          fieldType: "date"
        })
      }
    },
    handleDateFilter() {
      let dateActive = this.$store.state.filters.find(filter => filter.field === this.dateFieldName);
      if(this.selectedDate){
        if(dateActive){ // Remove date filter if active
          this.$store.commit('removeFilter', {
            id: dateActive.id
          })
        }

        if(this.selectedVariation){ // Type range -> from X to Y
          this.$store.commit('setFilter', {
            field: this.dateFieldName,
            from: dayjs.utc(this.selectedDate).subtract(this.departDelta, 'day').format('YYYY-MM-DD'),
            to: dayjs.utc(this.selectedDate).add(this.departDelta, 'day').format('YYYY-MM-DD'),
            id: `${this.dateFieldName}-${this.selectedDate}-${this.selectedVariation}`,
            breadcrumbs: true,
            title: this.title,
            type: "range",
            fieldType: "date"
          })
        } else {
          this.$store.commit('setFilter', { // Type value -> date = X
            field: this.dateFieldName,
            value: this.selectedDate,
            id: `${this.dateFieldName}-${this.selectedDate}`,
            breadcrumbs: true,
            title: this.title,
            type: "value",
            fieldType: "date"
          })
        }
      } else if(dateActive) {
        this.$store.commit('removeFilter', {
          id: `${this.dateFieldName}-${this.selectedDate}`
        })
      }
    },
    handleDurationFilter() {
      let filterActive = this.$store.state.filters.find(filter => filter.field === 'duration');
      if(filterActive && filterActive.value === this.selectedDuration){ // Already have a value selected
        return;
      }

      if(this.selectedDuration){
        this.$store.commit('setFilter', {
          field: 'duration',
          value: this.selectedDuration,
          id: `duration-${this.selectedDuration}`,
          breadcrumbs: true,
          title: "Durée",
          type: "value",
        })
      } else {
        this.$store.commit('removeFilter', {
          id: `duration-${this.selectedDuration}`
        })
      }
    },
    toggleVariationForDateFacet(value) {
      this.$emit('change-is-variation-active', value);
    }

  },
  created() {
    this.dateFieldName = this.fields.find(f => ['date', 'dateDepart', 'dateRetourn'].includes(f.field))?.field || this.dateFieldName;

    // Init all variables if some filter was define
    let selectedDuration = this.$store.state.filters.find(filter => filter.field === 'duration');
    if(selectedDuration) this.selectedDuration = selectedDuration.value;

    let selectedDate = this.$store.state.filters.find(filter => filter.field === this.dateFieldName);
    if(selectedDate && selectedDate.value) {
      this.selectedDate = selectedDate.value ;
    } else if(selectedDate && selectedDate.to && selectedDate.from){
      this.toggleVariationForDateFacet(true);
      this.selectedDate = dayjs.utc(selectedDate.from, 'YYYY-MM-DD').add(this.departDelta, 'day').format('YYYY-MM-DD');
    }

    // Get min date from available dates and set the date picker to start at that month
    let dates = this.handleItems(this.dateFieldName).items;
    if(dates && dates.length){
      dates.sort((a,b) => a.value - b.value);
      this.initialDate = dayjs.utc().format('YYYY-MM-DD');
    }
  },
  watch: {
    date(val) {
      if(!val){
        this.selectedDate = null;
        this.toggleVariationForDateFacet(null);
      }
    },
    duration(val) {
      if(!val){
        this.selectedDuration = null;
      }
    },
    selectedVariation(val) {
      this.toggleVariationForDateFacet(val);
    },
    showMore() {
      this.$emit('show-changed');
    }
  }
};
</script>
<style lang="scss">
  .block {
    display: block
  }
</style>